export function extractErrorMessage(err: any, fallback = 'حدث خطأ غير متوقع'): string {
  try {
    if (!err?.error && !err.errors) return fallback;

    if (err?.error?.error?.message && typeof err.error.error.message === 'string') {
      return err.error.error.message;
    }

    if (err?.error?.message && typeof err.error.message === 'string') {
      return err.error.message;
    }

    const errorValues = Object.values(err.error ?? err.errors);

    if (!errorValues.length) return fallback;

    if (Array.isArray(errorValues) && errorValues.every(e => typeof e === 'string')) {
      return errorValues.join(', ');
    }

    const firstError = errorValues[0];

    // if Array
    if (Array.isArray(firstError)) {
      return firstError.join(', ');
    }

    // if Object
    if (typeof firstError === 'object' && firstError !== null && !Array.isArray(firstError)) {
      return Object.values(firstError).join(', ');
    }

    if (typeof firstError === 'string') {
      return firstError;
    }

    return fallback;
  } catch (error) {
    return fallback;
  }
}
